import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import omit from 'lodash/omit';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';
import * as styles from './IrisPage.css';
import ShopTheImage from '../Stylitics/ShopTheImageWidget';
import withReducerSaga from '../../hoc/ReducerRegistry/withReducerSaga';
import IrisReducer from '../../reducers/IrisReducer';
import IrisSaga from '../../sagas/IrisSaga';
import IrisActions from '../../actions/IrisAction';
import {
    selectShouldRender,
    selectPreferences,
    selectFeatureFlags,
    selectDeviceType,
    isPreview as selectIsPreview,
} from '../../selectors/ContextSelector';
import { selectIrisSeoMeta, selectIrisData } from '../../selectors/IrisPageSelector';
import defaultWrapperRenderer from './defaultWrapperRenderer';
import renderCurrentComponent from './renderCurrentComponent';
import generateComponentKeyString from './generateComponentKeyString';
import { RECOMMENDATION_SOURCE_TYPE_SOURCE } from '../../common/Constants';

const cx = classNames.bind(styles);
const gridcomponent = 'gridcomponent';

/** Zone render allows us to override or customize the component rendering in given zone * */
const findZoneRenderer = (zoneRenderers, zone) => {
    if (!zoneRenderers || !zone || !Array.isArray(zoneRenderers)) return false;

    const zoneRenderer = zoneRenderers.find((render) => {
        if (render.zone === zone) return true;
        return null;
    });
    const renderer = get(zoneRenderer, 'renderer', false);

    return renderer || false;
};

export class IrisPage extends Component {
    static defaultProps = {
        actions: {},
        aggregateAPI: false,
        colWrapperRenderer: defaultWrapperRenderer,
        currentURL: '',
        deviceType: {},
        disableIrisCall: false,
        doNotRender: false,
        featureFlags: {},
        irisClientCall: true,
        irisComponents: {},
        irisData: {},
        irisFallbackEnabled: false,
        irisFallbackPreferences: {},
        irisPageSpecificComponents: {},
        isPreview: false,
        limitInitialComponentsRendered: null,
        pageType: '',
        params: {},
        postProcessor: undefined,
        preferences: {},
        redirectAction: undefined,
        seoMetaData: {},
        shouldRender: true,
        tag: 'div',
        theme: '',
        departmentLowerZoneSm: false,
        handleDepartmentPage2ColCallback: null,
        zoneRenderer: [],
        height: 100,
        offset: 300,
        location: {},
        hostname: 'www.jcpenney.com',
        enableCanonicalFallback: true,
        enableIrisManualIndexing: true,
        groupId: '',
    };

    /* eslint-disable react/sort-comp */
    rootLevelObjectName = 'content';

    tag = 'span';

    defaultRowClass = cx('row', 'col-12');

    irisColClassName = 'col';

    irisCompleteComponentList = {};

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        aggregateAPI: PropTypes.bool,
        colWrapperRenderer: PropTypes.func,
        currentURL: PropTypes.string,
        deviceType: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        disableIrisCall: PropTypes.bool,
        doNotRender: PropTypes.bool,
        featureFlags: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        irisClientCall: PropTypes.bool,
        irisComponents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        irisData: PropTypes.object,
        irisFallbackEnabled: PropTypes.bool,
        irisFallbackPreferences: PropTypes.object,
        irisPageSpecificComponents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isPreview: PropTypes.bool,
        limitInitialComponentsRendered: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
        pageType: PropTypes.bool,
        params: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        postProcessor: PropTypes.func,
        preferences: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        redirectAction: PropTypes.func,
        seoMetaData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        shouldRender: PropTypes.bool,
        tag: PropTypes.string,
        theme: PropTypes.string,
        departmentLowerZoneSm: PropTypes.bool,
        handleDepartmentPage2ColCallback: PropTypes.func,
        zoneRenderer: PropTypes.array,

        // when using react rendering stretigies use this props to pass height and offset to ref div
        offset: PropTypes.number,
        height: PropTypes.number,
        location: PropTypes.object,
        hostname: PropTypes.string,
        enableCanonicalFallback: PropTypes.bool,
        enableIrisManualIndexing: PropTypes.bool,
        groupId: PropTypes.string,
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (!this.props.doNotRender) {
            this.irisCompleteComponentList = {
                ...this.props.irisComponents,
                ...this.props.irisPageSpecificComponents,
            };
            this.irisComponentsWithoutGrid = omit(this.irisCompleteComponentList, [gridcomponent]);
            if (
                (this.props.isPreview && !isEmpty(this.props.params)) ||
                (isEmpty(this.props.irisData) && this.props.irisClientCall)
            ) {
                this.props.actions.getIrisTemplateData(
                    this.props.params,
                    this.props.aggregateAPI,
                    this.props.postProcessor,
                    this.props.irisFallbackEnabled,
                    this.props.irisFallbackPreferences,
                    this.props.redirectAction,
                    this.props.disableIrisCall
                );
            }
        }
    }

    componentDidMount() {
        if (
            !__SERVER__ &&
            this.props.featureFlags.enableSmoothScrollIOSGallerySearch &&
            findMobileOS() === 'iOS'
        ) {
            // only for PLP/SRP
            window.addEventListener(
                'click',
                () => {
                    if (document.documentElement.classList.contains('scroll-smooth')) {
                        document.documentElement.classList.remove('scroll-smooth');
                    }
                },
                true
            );
        }
    }

    // TODO: Think about this again.
    // shouldComponentUpdate() {
    //     if (!this.props.irisData) {
    //         return true;
    //     }
    //     return false;
    // }

    parseOneRow(rowData) {
        let retOneRow = null;
        // TODO: Refactor
        // props.tag or props.rowTag?
        const Tag = this.props.tag;
        const templateLocal = rowData.template || this.defaultRowClass;
        const { featureFlags, hasSearchResults } = this.props;

        if (rowData.columns && rowData.columns.length) {
            // check if template name is part of zone renderers for dept page
            const zoneRenderer = findZoneRenderer(this.props.zoneRenderer, rowData.template);
            // if zonerender found, call zone render instead for rowData
            const parsedRowData = zoneRenderer ? zoneRenderer(rowData, rowData.columns) : rowData;

            const key = parsedRowData.columns.map((column) => column.zoneDisplayName).join(',');
            let className = `${cx(templateLocal)}`;
            if (
                parsedRowData.columns[0].zone === 'GRID' &&
                featureFlags?.enableVerticalProductImages &&
                hasSearchResults
            ) {
                className += ` ${cx('verticalImageGrid')}`;
            }
            retOneRow = (
                <Tag className={className} key={key}>
                    {this.oneRowGen(parsedRowData)}
                </Tag>
            );
        } else {
            /* istanbul ignore next */
            console.warn('IRIS: columns not found in response');
        }
        return retOneRow;
    }

    oneRowGen(rowData) {
        const fullColumn = [];
        const { departmentLowerZoneSm, handleDepartmentPage2ColCallback } = this.props;
        // TODO: Refactor: Should we use lodash to keep the code cleaner
        /* istanbul ignore else */
        if (rowData.columns && rowData.columns.length) {
            rowData.columns.forEach((oneCol, index) => {
                fullColumn.push(
                    <div
                        key={oneCol.zone || oneCol.zoneDisplayName || index}
                        className={cx(this.irisColClassName, {
                            departmentLowerZoneSm:
                                oneCol.zoneDisplayName === 'S2-b' && departmentLowerZoneSm,
                        })}
                        data-automation-id={`zone-${oneCol.zoneDisplayName}`}
                        ref={handleDepartmentPage2ColCallback}
                    >
                        {this.renderComponents(oneCol)}
                    </div>
                );
            }, this);
        } else {
            console.warn('IRIS: columns not found in response');
        }
        return fullColumn;
    }

    renderComponents(oneCol) {
        const {
            preferences,
            featureFlags,
            deviceType,
            pageType,
            isPreview,
            params,
            limitInitialComponentsRendered,
            offset,
            height,
            groupId,
        } = this.props;
        const propsData = {
            preferences,
            featureFlags,
            deviceType,
            pageType,
            isPreview,
            offset,
            height,
            // Forwarded to rendered iris components (e.g. RecommendationSwitch)
            // so a page can scope a rec pod to a department/category. Only
            // included when set, so components that don't use it are unaffected.
            ...(groupId ? { groupId } : {}),
        };
        let sourceUrlFound = null;
        if (!isEmpty(params)) {
            const sourceUrl = params;
            const splitUrl = sourceUrl.split('&');
            sourceUrlFound =
                splitUrl &&
                splitUrl.find((element) => element.includes(RECOMMENDATION_SOURCE_TYPE_SOURCE));
        }
        const colDom = [];
        /* istanbul ignore else */
        // in case of zoneRenderer though components length is 0 but we are still pushing some components
        if (oneCol.components && (oneCol.components.length || this.props.zoneRenderer)) {
            // Page can supply the wrapper html if they need to render
            const wrapperRenderer = this.props.colWrapperRenderer;
            const zoneRenderer = findZoneRenderer(this.props.zoneRenderer, oneCol.zone);
            // if zonerender found, collate all the component and call zone render instead
            if (zoneRenderer) {
                const renderedZoneComponents = zoneRenderer(
                    oneCol.zone,
                    oneCol.components,
                    this.irisCompleteComponentList,
                    this.irisComponentsWithoutGrid,
                    propsData
                );
                renderedZoneComponents.forEach((renderedComponent) =>
                    colDom.push(renderedComponent)
                );
            } else {
                oneCol.components.forEach((component, index) => {
                    const item = wrapperRenderer(
                        renderCurrentComponent(
                            component,
                            index,
                            this.irisCompleteComponentList,
                            this.irisComponentsWithoutGrid,
                            propsData,
                            limitInitialComponentsRendered
                        ),
                        generateComponentKeyString(component.componentType, index)
                    );
                    colDom.push(item);
                });
            }
        } else {
            console.warn('IRIS: components is missing in response');
        }
        return sourceUrlFound ? !__SERVER__ && colDom : colDom;
    }

    parseRow() {
        const rootNode = this.props.irisData[this.rootLevelObjectName];
        const fullNode = [];
        if (rootNode && !isEmpty(rootNode.rows)) {
            rootNode.rows.forEach((oneRowData, index) => {
                fullNode.push(this.parseOneRow(oneRowData, index));
            }, this);
        } else {
            console.warn('IRIS: rows not found in response');
        }

        return fullNode;
    }

    addSeoMetaTag() {
        const {
            seoMetaData,
            location,
            hostname = 'www.jcpenney.com',
            featureFlags: { enableCanonicalFallback = true, enableIrisManualIndexing = true },
        } = this.props;
        const seoContent = seoMetaData.content || {};
        const MetaTag = this.irisCompleteComponentList.seotag.component;
        /* istanbul ignore next */
        const { preferences = {}, deviceType = {}, currentURL = '' } = this.props;
        const noIndexNoFollowRequired = seoContent.noIndexNoFollow || false;

        let seoComponent = null;

        try {
            seoComponent = (
                <MetaTag
                    canonicalURL={currentURL}
                    data-automation-id="seoContent"
                    deviceType={deviceType}
                    hostname={hostname}
                    location={location}
                    noIndexNoFollowRequired={noIndexNoFollowRequired}
                    preferences={preferences}
                    seoBlock={seoContent}
                    enableCanonicalFallback={enableCanonicalFallback}
                    enableIrisManualIndexing={enableIrisManualIndexing}
                />
            );
        } catch (e) {
            /* istanbul ignore next */
            console.warn('IRIS: seo meta tag not loaded, check api response');
        }

        return seoComponent;
    }

    render() {
        const {
            doNotRender,
            featureFlags,
            pageType,
            preferences: {
                styliticsWidget: { pageTypeInclusionList = [] } = {},
                shopTheImageWidget: {
                    pageTypeInclusionList: legacyPageTypeInclusionList = [],
                } = {},
            } = {},
            shouldRender,
            theme,
        } = this.props;
        const inclusionList = pageTypeInclusionList.length
            ? pageTypeInclusionList
            : legacyPageTypeInclusionList;
        const shouldRenderShopTheImage = inclusionList.includes(pageType);
        if (doNotRender) return null;
        return shouldRender ? (
            <div
                id="containerWidthIris"
                className={`${dt(['mx-auto', 'my-0', 'w-full', 'overflow-hidden', 'pt-4'])} ${cx(
                    styles.containerWidth,
                    theme
                )}`}
            >
                {/* <LoadSVG svgPaths={[coreSprite, siteSprite]} /> */}
                {this.addSeoMetaTag()}
                {this.parseRow()}
                {featureFlags.enableShopTheImage && shouldRenderShopTheImage && (
                    <ShopTheImage
                        preferences={this.props.preferences}
                        featureFlags={featureFlags}
                    />
                )}
            </div>
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    seoMetaData: selectIrisSeoMeta(state),
    irisData: selectIrisData(state),
    shouldRender: selectShouldRender(state),
    featureFlags: selectFeatureFlags(state),
    preferences: selectPreferences(state),
    deviceType: selectDeviceType(state),
    isPreview: selectIsPreview(state),
    hostname: state?.context?.hostname,
    hasSearchResults: state?.countOfSearchResults || 0,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(IrisActions, dispatch),
});

export default withReducerSaga(
    [IrisReducer],
    [IrisSaga]
)(connect(mapStateToProps, mapDispatchToProps)(IrisPage));
